import { find } from 'lodash';
import { ConversationResponse } from '../models/conversation-response.models';
import { Participant } from '../models/participant.model';
import { ConnectionState } from '../models/connection-state.enum';
import { ParticipantPurpose } from '../models/participant-purpose.enum';

export abstract class ConversationConverterService {
  protected static readonly activeParticipantMessageTypes = new Set<string>([
    ConnectionState.Alerting,
    ConnectionState.Connected
  ]);

  protected hasUnfilledWrapup(participant: Participant): boolean {
    return (participant.wrapupRequired && !participant.wrapup);
  }

  protected getAgentParticipant(conversation: ConversationResponse, agentUserId?: string): Participant {
    return find(conversation.participants, { purpose: ParticipantPurpose.Agent, userId: agentUserId });
  }

  protected getCustomerParticipant(conversation: ConversationResponse): Participant {
    return find(conversation.participants, { purpose: ParticipantPurpose.Customer });
  }

  protected getExternalParticipant(conversation: ConversationResponse): Participant {
    return find(conversation.participants, { purpose: ParticipantPurpose.External });
  }

  protected getAcdParticipants(conversation: ConversationResponse): Participant[] {
    return conversation.participants.filter(p => p.purpose === ParticipantPurpose.ACD);
  }
}
